import script from "./SchiffPitchforkTool.vue?vue&type=script&lang=js"
export * from "./SchiffPitchforkTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__